import PropTypes from 'prop-types';
import React from 'react';

const AnalysisDocumentsListItem = ({ onDocumentDelete, isAdminLocked, name, description, url }) => (
    <div className="container">
        <div className="row" title={description}>
            <div className="col-sm">
                <strong>{name}</strong>
            </div>
            <div className="col-sm">
                <a href={url} target="_blank" rel="noopener noreferrer">
                    {url}
                </a>
            </div>
            {!isAdminLocked && (
                <div>
                    <button type="button" className="btn btn-link pt-0" onClick={onDocumentDelete}>
                        Delete
                    </button>
                </div>
            )}
        </div>
    </div>
);

AnalysisDocumentsListItem.propTypes = {
    onDocumentDelete: PropTypes.func.isRequired,
    isAdminLocked: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    description: PropTypes.string,
};

export default AnalysisDocumentsListItem;
